import React from 'react';
import PropTypes from 'prop-types';
import addBindTo from '../../Provider/hocs/addBindTo';

const Oval = ({ width, height, label, radius }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 38 38"
    xmlns="http://www.w3.org/2000/svg"
    stroke="var(--primary-500)"
    aria-label={label}
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)" strokeWidth="2">
        <circle strokeOpacity=".5" cx="18" cy="18" r={radius} />
        <path d="M36 18c0-9.94-8.06-18-18-18">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 18 18"
            to="360 18 18"
            dur="1s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </g>
  </svg>
);

Oval.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  radius: PropTypes.number,
};

Oval.defaultProps = {
  height: 80,
  width: 80,
  label: 'audio-loading',
  radius: 18,
};

export default addBindTo((context) => ({
  theme: context.theme,
}))(Oval);
